import axiosInstance from "@/api/axios-instance";

export async function getBundles({
  page,
  status,
  product_id,
  limit,
  region,
}: {
  page: number;
  status?: string;
  product_id?: string;
  limit?: number;
  region?: string;
}) {
  const params: Record<string, any> = { page };
  if (limit) params.limit = limit;

  if (status && status !== "ALL") {
    params.status = status;
  }

  if (product_id && product_id !== "ALL") {
    params.product_id = product_id;
  }

  if (region) {
    params.region = region;
  }

  const response = await axiosInstance.get("/bundle", {
    params,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("bundles are not loaded");
  }

  const { bundles, nextPage, lastPage, page: currentPage, total } = response.data;
  return {
    bundles,
    nextPage,
    lastPage,
    currentPage,
    total,
  };
}